module.exports = __webpack_public_path__ + "img/sweden-congenital-and-perinatal-diseases-male.6b7b5bc4.png";